export const BACKGROUND_COLOR_CHANGE_ON_HOVER = true;
